import { IOrganization } from "../Organization/Organization";
import { IFormat } from "./Format";

export interface IFormatOrganization {
    formatId: string;
    format: IFormat;
    organizationId: number;
    organization: IOrganization;
}

export class FormatOrganization {
    formatId: string;
    format: IFormat;
    organizationId: number;
    organization: IOrganization;

    constructor()
    constructor(obj: IFormatOrganization)
    constructor(obj?: IFormatOrganization) {
        this.formatId = obj && obj.formatId || undefined;
        this.format = obj && obj.format || undefined;
        this.organizationId = obj && obj.organizationId || undefined;
        this.organization = obj && obj.organization || undefined;
    }
}